var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CrudTable',_vm._b({attrs:{"storeModule":_vm.storeModule,"showActionsPanel":false},scopedSlots:_vm._u([{key:"form",fn:function(ref){
var close = ref.close;
return [_c('DetachmentsOfflineOnlineForm',{attrs:{"showHeader":""},on:{"close":close}})]}},{key:"item.verbose_name",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'DetachmentsOfflineOnlineDetail', params: { id: item.id }}}},[_vm._v(" "+_vm._s(item.verbose_name)+" ")])]}}])},'CrudTable',_vm.crudTableConfig,false))}
var staticRenderFns = []

export { render, staticRenderFns }